import keycloak from "./keycloak";

export function LoginPage() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        background:
          "radial-gradient(1000px 600px at 15% 10%, #1e2a5a 0%, transparent 55%)," +
          "radial-gradient(900px 500px at 90% 90%, #0b3b52 0%, transparent 50%)," +
          "linear-gradient(135deg, #0b1020 0%, #16213e 60%, #0f3460 100%)",
        fontFamily: "var(--font-sans)",
      }}
    >
      <div
        style={{
          background: "rgba(255,255,255,0.98)",
          borderRadius: 20,
          padding: "44px 46px",
          width: 400,
          maxWidth: "100%",
          textAlign: "center",
          boxShadow: "0 30px 80px rgba(0,0,0,0.5)",
          border: "1px solid rgba(255,255,255,0.14)",
        }}
      >
        <div
          style={{
            width: 64,
            height: 64,
            margin: "0 auto 18px",
            borderRadius: 18,
            display: "grid",
            placeItems: "center",
            fontSize: 30,
            color: "#fff",
            background:
              "linear-gradient(135deg, #4f46e5 0%, #4338ca 55%, #312e81 100%)",
            boxShadow: "0 12px 28px rgba(79,70,229,0.45)",
          }}
        >
          ✈
        </div>
        <h1
          style={{
            fontSize: 27,
            fontWeight: 800,
            letterSpacing: "-0.02em",
            color: "#0f172a",
            margin: "0 0 6px",
          }}
        >
          AirProcurement
        </h1>
        <p style={{ color: "#64748b", fontSize: 14, margin: "0 0 30px" }}>
          AI-powered aviation procurement
        </p>

        <button
          style={{
            width: "100%",
            padding: "13px 0",
            background: "linear-gradient(180deg, #4f46e5 0%, #4338ca 100%)",
            color: "#fff",
            border: "none",
            borderRadius: 11,
            fontSize: 15,
            fontWeight: 700,
            cursor: "pointer",
            letterSpacing: 0.2,
            boxShadow: "0 8px 20px rgba(79,70,229,0.4)",
          }}
          onClick={() => void keycloak.login()}
        >
          Sign in with Keycloak →
        </button>

        <p
          style={{
            color: "#94a3b8",
            fontSize: 11.5,
            marginTop: 26,
            marginBottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 6,
          }}
        >
          <span aria-hidden>🔒</span> Secure access via Keycloak SSO
        </p>
      </div>
    </div>
  );
}
